module.exports = __webpack_public_path__ + "img/stamp-communication.753f8996.png";